module.exports = __webpack_public_path__ + "images/sapces-img-desktop.929d13520a5c044c2fddefa87a787ebb.png";